module.exports = __webpack_public_path__ + "src/assets/images/Macys_Logo_Nextgen.abb942263f942457a05dedfa395c71f7.svg";